import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router, RouteReuseStrategy } from '@angular/router';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DataSharingService } from 'src/app/services/data-sharing.service';
import { UserControllerService } from 'src/app/services/user-controller.service';
import { environment } from 'src/environments/environment';


interface Candidate {
  name: string,
  lastname: string,
  license: number,
  username: string,
  profile_picture: string,
  status: boolean,
  recruiter_name:string,
  recruiter_lastname:string
}
interface result {
  name: string,
  answersheet: string[],
  score: number,
  datestamp: string,
  weighing: number
}
interface missing {
  id: string,
  name: string,
  description: string
}


@Component({
  selector: 'app-candidate-card',
  templateUrl: './candidate-card.component.html',
  styleUrls: ['./candidate-card.component.scss']
})
export class CandidateCardComponent implements OnInit, OnChanges, OnDestroy {

  constructor(private _candidates: UserControllerService,
    private router: Router,
    private route: ActivatedRoute) { }

  tokeninfo = <any>JSON.parse(atob(sessionStorage.getItem('token')!.split('.')[1]))
  candidate_id = this.route.snapshot.paramMap.get('id')
  candidates: [Candidate, result[], missing[]] = [{
    name: '',
    lastname: '',
    license: 0,
    username: '',
    profile_picture: '',
    status: true,
    recruiter_name:'',
    recruiter_lastname:''
  },
  [{
    name: 'string',
    answersheet: [''],
    score: 0,
    datestamp: 'string',
    weighing: 0
  }],
  [{
    id: '',
    name: '',
    description: ''
  }]]
  displayedColumns: string[] = ['name', 'score', 'weighing', 'weighedscore', 'datestamp'];
  dataSource = [{ name: '', score: 0, datestamp: 0, weighing: 0 }];
  missing = [];
  average = 0;
  averageweighed = 0;
  totalweigh = 0;
  images = environment.localstatic
  indicator;


  ngOnInit(): void {
    this.route.paramMap.subscribe(resolve => {
      this.averageweighed = 0;
      this.average = 0;
      this.candidate_id = resolve.get('id')
      this._candidates.getCandidateInfo({ candidate_id: this.candidate_id }).subscribe(resolve => {
        console.log(resolve[0])
        this.candidates = resolve[0];
        this.dataSource = resolve[1];
        this.missing = resolve[2]
        console.log(this.dataSource)
        this.dataSource.forEach(element => {
          this.average = this.average + element.score
          this.totalweigh = this.totalweigh + element.weighing
          this.averageweighed = this.averageweighed + element.score * element.weighing
        })
        this.average = this.average / (this.dataSource.length) * 10
        this.averageweighed = this.averageweighed / this.totalweigh * 10
        this.indicator = this.averageweighed >= 9 && this.averageweighed <= 10 ? 'Riesgo muy Bajo' : this.averageweighed < 9 && this.averageweighed >= 8 ? 'Riesgo Bajo' : this.averageweighed <= 8.0 && this.averageweighed >= 7 ? 'Riesgo Medio' : this.averageweighed <= 7 ? 'Riesgo Alto' : ''
        //this.averageweighed = 5.5

      })
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnDestroy(): void {
  }
}
